import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const AdminAuthGuard = ({ children }) => {
  const { isAdmin } = useSelector((state) => state.auth);
  if (isAdmin)return <>{children}</>;
   else return <Navigate to="/admin/login" />;

};
export default AdminAuthGuard;